import { useEffect, useRef, useState } from 'react';

import type { RefObject } from 'react';

export const useTaskCommentInputSize = (containerRef: RefObject<HTMLElement>) => {
    const formRef = useRef<HTMLFormElement>(null);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [maxHeight, setMaxHeight] = useState(28);

    useEffect(() => {
        const container = containerRef.current;
        const form = formRef.current;
        const textarea = textareaRef.current;
        if (!container || !form || !textarea) return;

        const updateMaxHeight = () => {
            const styles = window.getComputedStyle(container);
            const containerHeight =
                container.clientHeight
                - parseFloat(styles.paddingTop)
                - parseFloat(styles.paddingBottom);
            const surroundingHeight = form.offsetHeight - textarea.offsetHeight;
            setMaxHeight(Math.max(28, Math.floor(containerHeight - surroundingHeight)));
        };

        updateMaxHeight();
        const observer = new ResizeObserver(updateMaxHeight);
        observer.observe(container);
        observer.observe(form);

        return () => observer.disconnect();
    }, [containerRef]);

    return { formRef, textareaRef, maxHeight };
};
